module.exports = __webpack_public_path__ + "static/media/medixine-suite-logo-bw.c9c115a4.svg";